import React from 'react';
import ConferenceRoom from './ConferenceRoom';
import ConferenceRoomContact from './ConferenceRoomContact';

const ConferenceRoomPage: React.FC = () => {
  return (
    <div className="conference-room-page">
      <ConferenceRoom />
      <ConferenceRoomContact />
    </div>
  );
};

export default ConferenceRoomPage;
